import React from 'react';
import {getUrlParameters} from "../utility";
import * as _ from "lodash";

let _otSessionintervalId;
let _kickOutTimerIntervalId

/**
 * @function a valid broadcast is decided if the location params has all 3 objects session_id, token, broadcast_id
 * if any of this is missing we tell it is not valid broadcast
 * @param location
 * @returns {Promise<any>}
 */
export const checkValidBroadcast = (location) => {
    return new Promise((resolve, reject) => {
        if (location.hasOwnProperty("search")) {
            let broadcastDetails = getUrlParameters(location.search);
            if (broadcastDetails.hasOwnProperty("session_id") &&
                broadcastDetails.hasOwnProperty("token") &&
                broadcastDetails.hasOwnProperty("broadcast_id")) {
                //proceed with this screen
                resolve(broadcastDetails);
            } else {
                //else throw the user back to create broadcast screen
                reject("Missing session_id or token or broadcast_id")
            }
        } else {
            reject("Missing search key in location")
        }
    })
};

export const getBroadcastID = (location) => {
    return new Promise((resolve, reject) => {
        if (location.hasOwnProperty("search")) {
            let broadcastDetails = getUrlParameters(location.search);
            if (broadcastDetails.hasOwnProperty("broadcast_id")) {
                //proceed with this screen
                resolve(broadcastDetails);
            } else {
                //else throw the user back to create broadcast screen
                reject("broadcast_id")
            }
        } else {
            reject("Missing search key in location")
        }
    })
};

/**
 * @function this function is use to update Elapsed time on broadcaster broadcast screen
 * @param first
 * @param second
 * @returns {string}
 */
const setPosition = (first, second,third) => {

    let _firstPosition = "00", _secondPosition = "00", _thirdPosition = "00";

    if (parseInt(first).toString().length === 1) {
        _firstPosition = `0${parseInt(first)}`
    } else {
        _firstPosition = `${parseInt(first)}`
    }

    if (parseInt(second).toString().length === 1) {
        _secondPosition = `0${parseInt(second)}`
    } else {
        _secondPosition = `${parseInt(second)}`
    }

    if (parseInt(third).toString().length === 1) {
        _thirdPosition = `0${parseInt(third)}`
    } else {
        _thirdPosition = `${parseInt(third)}`
    }

    return `${_firstPosition}:${_secondPosition}:${_thirdPosition}`
}

/**
 * @function initiates the elapsed time on broadcaster broadcast screen
 * @param callback
 */
export const startOTSessionCountdown = (callback) => {

    let duration = 0;
    // Update the count down every 1 second
    let interval = 1000;
    let durationUI = "00:00:00";

    _otSessionintervalId = setInterval(function () {

        duration++;
        if (duration < 60) {
            durationUI = setPosition("00", "00", duration);
        } else {
            const thirdPos = duration % 60, secondPos = duration / 60, firstPos = duration / 3600;
            if (firstPos >= 1) {
                durationUI = setPosition(firstPos, secondPos, thirdPos);
            } else {
                durationUI = setPosition("00",secondPos, thirdPos);
            }
        }

        callback(durationUI);

    }, interval);
}

/**
 *
 */
export const endOTSessionCountdown = () => {
    clearInterval(_otSessionintervalId);
}

export const startKickOutCountdownTimer = (callback) => {
    let counter = 60;
    // Update the count down every 1 second
    let interval = 1000;
    _kickOutTimerIntervalId = setInterval(function() {
        counter--;
        if (counter === 0) {
            clearInterval(_kickOutTimerIntervalId);
            callback()
        }
    }, interval);
}

export const endKickOutCountDownTimer = () => {
    clearInterval(_kickOutTimerIntervalId);
}

/**
 * @function populates the live chat by parsing through the whole signal array
 * @param handleUserNameClickEvent
 * @param signalArray
 * @returns {Array}
 */
export const getChatObjects = (handleUserNameClickEvent, signalArray,actionsAllowed) => {
    return _.map(signalArray, (signal, index) => {
        const style = (signal.type === "signal:Viewer" && actionsAllowed) ? {cursor: 'pointer'} : {}
        var elmnt = document.getElementById("divElem");
        if(elmnt){
            elmnt.scrollTop = elmnt.scrollHeight + 36;
            return (
                <p key={index}>
                <span style={style} onClick={() => {
                    if (signal.type === "signal:Viewer" && actionsAllowed) {
                        handleUserNameClickEvent(signal)
                    }
                }}>{signal.type.indexOf("signal:VuePay") >= 0 ? "VuePay" : signal.userData.username} -</span> {signal.text}
                </p>
            )
        }
    })
}

/**
 * @function this method is invoked to check if one to one session is allowed for a session
 * @param props
 * @returns {boolean|*}
 */
export const isOneToOneSessionAllowed = (props) => {
    if (props.availabilityID === -1) {
        return props.broadcast !== null &&
            props.broadcast.hasOwnProperty("one_to_one_session_allow") &&
            props.broadcast.one_to_one_session_allow &&
            (props.broadcast.hasOwnProperty("private") &&
                Array.isArray(props.broadcast.private) &&
                props.broadcast.private.length === 0)
    } else {
        return props.broadcast !== null &&
            props.broadcast.hasOwnProperty("one_to_one_session_allow") &&
            props.broadcast.one_to_one_session_allow
    }
}

/**
 * @function this method is invoked to check if the running session is free or paid
 * @param props
 * @returns {boolean}
 */
export const isFreeSession = (props) => {
    return props.broadcast !== null &&
        props.broadcast.hasOwnProperty("broadcast_type") &&
        props.broadcast.broadcast_type === "free";
}

let countdownFunc = null;
export const startCountdownFunc = (wait_time_in_seconds, callback) => {
    // The data/time we want to countdown to
    let countDownDate = new Date();
    countDownDate.setSeconds(countDownDate.getSeconds() + wait_time_in_seconds);

    if (countdownFunc === null) {
        // Run myfunc every second
        countdownFunc = setInterval(function () {
            let now = new Date().getTime();
            let timeleft = countDownDate - now;

            // Calculating the days, hours, minutes and seconds left
            let days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
            let hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
            if(minutes.toString().length < 2){
                minutes = "0"+minutes;
            }
            let seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
            if(seconds.toString().length < 2){
                seconds = "0"+seconds;
            }
            // Display the message when countdown is over
            if (timeleft < 0) {
                clearInterval(countdownFunc);
                callback(-1,`00:00`);
            }else{
                callback(timeleft,`${minutes}:${seconds}`);
            }

        }, 1000);
    }
};

export const endCountdownFunc = ()=>{
    clearInterval(countdownFunc);
};

export const getSessionStatus = (broadcast,get_broadcast_earnings,currency_symbol,total,private_broadcast_id) => {

    const isGroup = (broadcast !== null &&
        (
            (broadcast.hasOwnProperty("broadcast_type") && broadcast.broadcast_type !== "free") ||
            (broadcast.hasOwnProperty("private") && !Array.isArray(broadcast.private))
        )
    );

    const isPrivate = private_broadcast_id !== -1;


    if(isPrivate){
        if(broadcast && broadcast.hasOwnProperty("one_to_one_session_price") && broadcast.one_to_one_session_price === 0){
            return "Private session";
        }else{
            return `Earnings: ${currency_symbol}${total}`
        }
    }else if (isGroup) {
        //group i.e. can be free or paid
        if(get_broadcast_earnings.isFetching){
            return "...";
        }else{
            if(broadcast.broadcast_type === "free"){
                return "Free session";
            }else{
                return `Earnings: ${currency_symbol}${total}`
            }
        }
    }else{
        return "Free session";
    }
}